import { mediaUrl, SERVER_BASE } from '../services/api';

// Ayni koyu mavi efektle kaydedilmis eski API banner dosyalari.
// Bu liste yalnizca goruntuleme sirasindaki renk duzeltmesini secer;
// API'den gelen fotograf adresini degistirmez.
const DARK_BLUE_BANNER_URLS = new Set(
  [39, 40, 47, 49, 82].map((id) => `${SERVER_BASE}/api/dokumanlar/${id}/goster`),
);

export function hasDarkBlueHeroTone(imageUrl?: string): boolean {
  const source = mediaUrl(imageUrl)?.split(/[?#]/)[0].replace(/\/$/, '');
  return Boolean(source && DARK_BLUE_BANNER_URLS.has(source));
}
